// Canonical market registry for the per-user primary-market / country setting (plan 224).
// Mirrors the backend source of truth in `accounts/markets.py` — keep the two in sync.
// `defaultSymbol` is a chart-datafeed-resolvable EXCHANGE:TICKER string.

export const MARKETS = {
  BD: { label: 'Bangladesh', exchange: 'DSE', defaultSymbol: 'DSEBD:SQURPHARMA' },
  US: { label: 'United States', exchange: 'NASDAQ / NYSE', defaultSymbol: 'NASDAQ:AAPL' },
  SA: { label: 'Saudi Arabia', exchange: 'TADAWUL', defaultSymbol: 'TADAWUL:2222' },
};

// Order shown in the Settings dropdown.
export const MARKET_CODES = ['BD', 'US', 'SA'];

export const DEFAULT_MARKET = 'BD';

// The chart's ultimate fallback if a user has no (or an unknown) market set.
export const FALLBACK_SYMBOL = 'NASDAQ:AAPL';

export function defaultSymbolFor(code) {
  return MARKETS[code]?.defaultSymbol || FALLBACK_SYMBOL;
}
